
import BreadcrumbView from "../../common/breadcrumb/breadcrumb.html";
import PersonsReportsListView from "./persons_reports-list.html";

angular.module("persons_reports", [])

    .config(['$stateProvider' ,function ($stateProvider) {
        $stateProvider
            .state('persons_reports', {
                url: "/persons_reports",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
                data: { pageTitle: "Informes de Autoridades" }
            })
            .state('persons_reports.list', {
                url: "/list",
                controller: "PersonsReportsCtrl",
                template: PersonsReportsListView,
                data: { pageTitle: "Informes de Autoridades" }
            })            
        ;
    }])
;